var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGd = function SvgIconGd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M5.236 2.087A11.94 11.94 0 0 1 12 0c2.509 0 4.837.77 6.763 2.087L12 2.609z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "m12 12-.765-.766-.204.364z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#496E2D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.515 3.515c-4.687 4.686-4.687 12.284 0 16.97L12 12zM20.485 3.516c4.687 4.686 4.687 12.284 0 16.97L12 12.002z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M12 16.174a4.174 4.174 0 1 0 0-8.348 4.174 4.174 0 0 0 0 8.348"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m12 7.826.935 2.88h3.028l-2.45 1.78.936 2.88-2.45-1.78-2.449 1.78.936-2.88-2.45-1.78h3.028z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#A2001D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.004 0h-.008a11.96 11.96 0 0 0-8.48 3.514h16.969A11.96 11.96 0 0 0 12.005 0M3.516 20.486A11.96 11.96 0 0 0 12 24c3.314 0 6.313-1.343 8.485-3.514z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 1.304.195.598h.628l-.508.37.194.597-.508-.37-.509.37.194-.597-.508-.37h.628zM9.09 1.304l.195.598h.628l-.508.37.194.597-.509-.37-.508.37.194-.597-.508-.37h.628zM14.91 1.304l.194.598h.629l-.509.37.194.597-.508-.37-.509.37.195-.597-.51-.37h.63zM12 21.13l.195.598h.628l-.508.369.194.598-.508-.37-.509.37.194-.598-.508-.37h.628zM9.09 21.13l.195.598h.628l-.508.369.194.598-.509-.37-.508.37.194-.598-.508-.37h.628zM14.91 21.13l.194.598h.629l-.509.369.194.598-.508-.37-.509.37.195-.598-.51-.37h.63zM3.657 11.802a1.043 1.043 0 0 1-1.764 1.116c-.558-.881-.234-2.321-.234-2.321s1.44.323 1.998 1.205"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M3.054 13.323a.522.522 0 1 0 0-1.044.522.522 0 0 0 0 1.043"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconGd;